import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { ActionPromptType } from "./action-prompt-type";
import { getAddPairForActionPrompts } from "./action-prompt-pairs";
import { IActionPromptsState } from ".";

export interface ICompleteActionPromptResponse {
    items: ActionPromptType[];
}

export const completeActionPrompt = createAsyncThunk<ICompleteActionPromptResponse>(
    'actionPrompts/complete',
    async () => await api.actionPrompts.complete()
);

export const formActionPrompts = (actionPrompts: ActionPromptType[]) => {
    return actionPrompts
        .map(action => ([action, ...getAddPairForActionPrompts(action)]))
        .flat()
        .filter(action => action !== ActionPromptType.NONE);
}

const completeActionPromptHandler = (builder: ActionReducerMapBuilder<IActionPromptsState>) => {
    builder
        .addCase(completeActionPrompt.pending, (state: IActionPromptsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(completeActionPrompt.fulfilled, (state: IActionPromptsState, action: PayloadAction<ICompleteActionPromptResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.items = formActionPrompts(action.payload.items);
        })
        .addCase(completeActionPrompt.rejected, (state: IActionPromptsState) => {
            state.loading = false;
            state.error = 'Unable to complete action prompt';
        });
};

export default completeActionPromptHandler;